
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IClassCode, ILookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * ItemClassLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemClassLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<IClassCode[]> {
        return this.$apiService.sendAuth("IItemClassLookupService/Lookup", pCriteria);
    }
}
